/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { App } from 'store/App';
import { Payment } from 'store/Payment';
import { ITipCalculator } from 'types';
import { buildHoldbackChangeLogEntries, updatePayeeWithNewEmployee } from 'utils';
import * as ActionTypes from './types';

const initialState: ITipCalculator | null = null;

const reducer: Reducer<ITipCalculator | null> = (state = initialState, action): ITipCalculator => {
  switch (action.type) {
    case App.SET_CURRENT_SITE:
    case Payment.CREATE_PAYMENT_SUCCESS: {
      return initialState;
    }
    case ActionTypes.TipCalculator.GET_POS_SUCCESS: {
      return {
        ...state,
        posResults: action.payload.response,
      };
    }
    case ActionTypes.TipCalculator.UPDATE_CALCULATOR_PAYMENTSET_REQUEST: {
      return {
        ...state,
        paymentSet: action.payload.paymentSet,
      };
    }
    case ActionTypes.TipCalculator.GET_CALCULATED_TIPS_SUCCESS: {
      return {
        ...state,
        results: action.payload.response,
      };
    }
    case ActionTypes.TipCalculator.UPDATE_CALCULATED_TIPS_RESULTS: {
      return {
        ...state,
        results: action.payload.results,
      };
    }
    case ActionTypes.TipCalculator.RESET_CALCULATOR_PAYMENTSET: {
      return {
        ...state,
        paymentSet: undefined,
      };
    }
    case ActionTypes.TipCalculator.SET_CALCULATOR_PAYEES: {
      return {
        ...state,
        payees: action.payload.payees,
      };
    }
    case ActionTypes.TipCalculator.SET_POS_RESULTS: {
      return {
        ...state,
        posResults: action.payload.data,
      };
    }
    case ActionTypes.TipCalculator.SET_CHANGE_LOG_ENTRIES: {
      return {
        ...state,
        changeLog: action.payload.entries,
      };
    }
    case ActionTypes.TipCalculator.UPDATE_PAYEE_HOLDBACK: {
      const { payee, holdback } = action.payload;
      if (!state?.payees) return state;
      return {
        ...state,
        payees: state.payees.map((p) => (p.id === payee.id ? { ...p, holdbackAmount: holdback, net: p.gross - holdback } : p)),
        changeLog: buildHoldbackChangeLogEntries({ payee, previousHoldback: payee.holdbackAmount, holdback }, state.changeLog || []),
      };
    }
    case ActionTypes.TipCalculator.UPDATE_PAYEE_NOTE: {
      const { payeeId, note } = action.payload;
      if (!state?.payees) return state;
      return {
        ...state,
        payees: state.payees.map((p) => (p.id === payeeId ? { ...p, note } : p)),
      };
    }
    case ActionTypes.TipCalculator.CONNECT_EMPLOYEE_TO_PAYEE: {
      const { employee, site, payrollTips } = action.payload;
      if (!state?.payees || !state.posResults || !state.results) return state;
      const { updatedPayees, updatedPosResults, updatedTipCalcResults } = updatePayeeWithNewEmployee(employee, site, state.payees, state.posResults, state.results, payrollTips);
      return {
        ...state,
        payees: updatedPayees,
        posResults: updatedPosResults,
        results: updatedTipCalcResults,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as tipCalculatorReducer };
